import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { leasingExpenseTypeFragment } from './fragments';

export const LEASING_EXPENSE_TYPE_DELETED = gql`
  subscription leasingExpenseTypeDeleted {
    leasingExpenseTypeDeleted {
      expenseTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const LEASING_EXPENSE_TYPE_SAVED = gql`
  subscription leasingExpenseTypeSaved {
    leasingExpenseTypeSaved {
      leasingExpenseType {
        ...leasingExpenseType
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${leasingExpenseTypeFragment}
  ${CommonFragments.messageHeaders}
`;
